import { useQuery } from 'urql';
import { graphql } from '@/gql/graphql';
import { useChatStore } from '@/stores/useChatStore';
import useCurrentUser from './useCurrentUser';

const GetUnseenMessageCount = graphql(/* GraphQL */ `
  query GetUnseenMessageCount($excludeChatId: uuid) {
    current_user {
      id
      unseen_message_count(args: { exclude_chat_id: $excludeChatId })
    }
  }
`);

export default function useUnseenMessageCount() {
  const viewedChatId = useChatStore((state) => state.viewedChatId);
  const [{ data, operation }] = useQuery({
    query: GetUnseenMessageCount,
    variables: { excludeChatId: viewedChatId },
  });
  const user = useCurrentUser();

  return (
    (operation?.variables.excludeChatId === viewedChatId
      ? data?.current_user?.unseen_message_count
      : undefined) ?? user?.unseen_message_count
  );
}
